// extracted by mini-css-extract-plugin
export default {"container":"Choice_container__dJ75c","pulse":"Choice_pulse__y4KSk","active":"Choice_active__G+5kA","label":"Choice_label__sVFtn","key":"Choice_key__GIPAY"};